import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.toggleEvents();
  }

  static targets = ["events"];

  declare readonly eventsTarget: HTMLInputElement;
  declare readonly hasEventsTarget: boolean;

  toggleEvents() {
    // The element is not mounted; nothing to do
    if (!this.hasEventsTarget) {
      return;
    }

    const alwaysDisabled =
      this.eventsTarget.dataset.isAlwaysDisabled === "true";

    if (alwaysDisabled) {
      return;
    }

    const attending = this.element.querySelector<HTMLInputElement>(
      'input[name="event_series_response[attending]"]:checked',
    );

    // Get all the nodes that are inputs related to events
    const eventInputs = this.eventsTarget.querySelectorAll<HTMLInputElement>(
      `input[name="event_series_response[event_ids][]"],
       input[name="event_series_response[event_ids]"]`,
    );

    const isAttending = attending?.value === "true";

    eventInputs.forEach((node) => {
      node.disabled = !isAttending;
    });
  }
}
